
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop - Component that scrolls the window to the top when the route changes
 * This ensures that when navigating between pages, the view always starts from the top
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    // If there's no hash in the URL, scroll to top immediately
    if (!hash) {
      window.scrollTo({
        top: 0,
        behavior: "instant", // Use instant instead of smooth to ensure immediate scroll
      });
    } 
    // If there is a hash, let the browser handle the anchor scroll
    else {
      // Slight delay to ensure DOM is ready
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
    }
  }, [pathname, hash]); // Trigger when pathname or hash changes
  
  return null;
};

export default ScrollToTop;
